const professional: string[] = [
  "Asst Manager",
  "Bar Tender/ Waitress/ Waiter/ Housekeeper/ Cashier",
  "Cabin Crew",
  "Clerical",
  "Driver/ Security/ Despatch",
  "Factory Worker",
  "General Worker",
  "GM/ AGM",
  "Hawker/ Taxi Driver",
  "Insurance Agent/ Salesman/ Promoter/ Direct selling",
  "Manager",
  "MD and above",
  "Officer/ Executive",
  "Own business",
  "Pensioner",
  "Police/ Navy/ Army/ Postman",
  "Professional (lawyer/ doctor, accountant, pilot & etc)",
  "Skill worker (technician, mechanic, nurse, etc)",
  "Others",
];

export default professional;
